import HhlaPageBase from './hhla-page-base'

HhlaPageBase.init()
